import { render, staticRenderFns } from "./ButtonRemove.vue?vue&type=template&id=474b3ff0"
import script from "./ButtonRemove.vue?vue&type=script&lang=js"
export * from "./ButtonRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports